import React from 'react';
import { Link } from 'react-router-dom';

export function PlansNotAvailable({ routes }) {
  return (
    <div className="plansContainer">
      <div className="noChangePlans">You are currently subscribed to the best plan available.</div>
      <Link to={routes.myAccount} className="cancelButton">
        Cancel
      </Link>
    </div>
  );
}
